import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import WebDevQuizContainer from "./WebDevQuizContainer";
import WebDevResults from "./WebDevResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";

export interface WebDevResult {
  questionId: number;
  selectedOption: number;
  scores: {
    designQuality: number;
    functionality: number;
    performance: number;
  };
}

const WebDevQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <UserInfoForm
            onSubmit={handleUserInfoSubmit}
            subtitle="Build a Website That Drives Real Results"
          />
        }
      />
      <Route
        path="quiz"
        element={<WebDevQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<WebDevResults />} />
    </Routes>
  );
};

export default WebDevQuiz;
